import React, { useEffect, useState } from 'react';
import type { Dispatch } from 'react';

import { Icon } from '@swf/sports/components';

import type { CashOutAction } from '../../hooks/useCashOut';

import styles from './CashOutError.scss';

interface Props {
  error: string;
  dispatchAction: Dispatch<CashOutAction>;
}

const CashOutError: React.FC<Props> = ({ error, dispatchAction }) => {
  const [isVisible, setVisible] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setVisible(false);
      dispatchAction({ type: 'CLEAR_ERROR' });
    }, 10000);

    return () => {
      clearTimeout(timeout);
    };
  }, [dispatchAction]);

  return isVisible ? (
    <div role="alert" className={styles.error}>
      <Icon name="error" className={styles.errorIcon} size="x2" />
      <span>{error}</span>
    </div>
  ) : null;
};

export default CashOutError;
